<section class="perfil" [class.perfil--compacto]="compacto" [class.perfil--recolhido]="!expandido"
         *ngIf="telefoneCompleto && (perfil || carregando || semHistorico || erro)"
         aria-label="Perfil do cliente" [attr.aria-busy]="carregando">
  <header class="perfil__header" [class.perfil__header--clicavel]="podeRecolher" (click)="podeRecolher && alterne()">
    <span class="perfil__symbol" aria-hidden="true"><i class="mdi mdi-account-heart-outline"></i></span>
    <div class="perfil__heading">
      <span class="perfil__eyebrow">PERFIL DO CLIENTE</span>
      <h3 *ngIf="perfil">{{ perfil.totalPedidos }} {{ perfil.totalPedidos === 1 ? 'pedido' : 'pedidos' }} nos últimos 12 meses
        <small *ngIf="clienteDesde">· desde {{ clienteDesde }}</small></h3>
      <h3 *ngIf="!perfil && semHistorico">Ainda sem pedidos nesta loja</h3>
      <h3 *ngIf="!perfil && carregando">Lendo o histórico…</h3>
      <!-- recolhido: os hábitos viram uma linha só de chips, cada um com o ícone do hábito -->
      <ul class="perfil__resumo" *ngIf="perfil && !expandido" aria-label="Resumo dos hábitos">
        <li *ngFor="let fato of fatos" [title]="fato.rotulo + ': ' + fato.valor + (fato.evidencia ? ' — ' + fato.evidencia : '')">
          <i class="mdi" [ngClass]="fato.icone" aria-hidden="true"></i>{{ fato.curto }}
        </li>
      </ul>
    </div>
    <span class="perfil__chip" *ngIf="perfil?.canal?.jaPediuPelaMia" title="Já fechou pedido conversando com a Mia">
      <i class="mdi mdi-robot" aria-hidden="true"></i> Já pediu pela Mia
    </span>
    <button type="button" class="perfil__icon" *ngIf="podeRecolher" (click)="$event.stopPropagation(); alterne()"
            [attr.aria-expanded]="expandido" [attr.aria-label]="expandido ? 'Recolher perfil' : 'Expandir perfil'">
      <i class="mdi" [class.mdi-chevron-up]="expandido" [class.mdi-chevron-down]="!expandido" aria-hidden="true"></i>
    </button>
  </header>

  <div class="perfil__loading" *ngIf="carregando && !perfil" role="status"><span></span><span></span></div>

  <!-- expandido: um cartão por hábito, ícone próprio, rótulo, valor e a evidência embaixo -->
  <dl class="perfil__fatos" *ngIf="perfil && expandido">
    <div class="perfil__fato" *ngFor="let fato of fatos" [class.perfil__fato--largo]="fato.largo">
      <span class="perfil__fato-icone" aria-hidden="true"><i class="mdi" [ngClass]="fato.icone"></i></span>
      <dt>{{ fato.rotulo }}</dt>
      <dd><strong>{{ fato.valor }}</strong><small *ngIf="fato.evidencia">{{ fato.evidencia }}</small></dd>
    </div>
  </dl>

  <p class="perfil__hint" *ngIf="perfil && expandido && !compacto">Hábitos são sugestão: confirme com o cliente antes de fechar. Troco é sempre perguntado.</p>

  <div class="perfil__error" *ngIf="erro" role="alert">
    <i class="mdi mdi-alert-circle-outline" aria-hidden="true"></i><span>{{ erro }}</span>
    <button type="button" (click)="carregue()" [disabled]="carregando">Tentar de novo</button>
  </div>
</section>
